/* ============
 * Routes File
 * ============
 *
 * The routes and redirects are defined in this file
 */

import athletePage from './pages/athlete/index/index.vue'
import athletesPage from './pages/athletes/index/index.vue'
import hofPage from './pages/hof/index/index.vue'
import homePage from './pages/home/index/index.vue'
import teamPage from './pages/team/index/index.vue'
import teamsPage from './pages/teams/index/index.vue'

/**
 * The routes
 *
 * @type {object} The routes
 */
export default [
  // Home
  {
    path: '/home',
    name: 'home.index',
    component: homePage,
  },

  // Team
  {
    path: '/team/:teamId',
    name: 'team.index',
    component: teamPage,
  },

  // Teams
  {
    path: '/find-a-team',
    name: 'teams.index',
    component: teamsPage,
  },

  // Hall of Fame
  {
    path: '/hall-of-fame/:decade',
    name: 'hof.index',
    component: hofPage,
  },

  // Athletes
  {
    path: '/find-an-athlete/:noPage',
    name: 'athletes.index',
    component: athletesPage,
  },
  {
    path: '/find-an-athlete?q=:searchTerm',
    name: 'athletes.search',
    component: athletesPage,
  },

  // Athlete
  {
    path: '/athlete/:athleteId',
    name: 'athlete.index',
    component: athletePage,
  },
  {
    path: '/athlete/:athleteId/:hof',
    name: 'athlete.hof',
    component: athletePage,
  },

  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/*',
    redirect: '/home',
  },
]
